import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SxProps } from '@mui/system';
import { Alert, IconButton, Snackbar } from '@mui/material';
// ICONS
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// HOOKS
import { useAppSelector } from '../../hooks';
// STORE
import { getSuccessState, resetMessage } from '../../store/SuccessSlice';

interface IAlertData {
  visible: boolean;
  message: string;
}

const contentStyles: SxProps = {
  backgroundColor: 'rgb(237, 247, 237)',
  color: 'rgb(76, 175, 80)',
};
const initialState: IAlertData = {
  visible: false,
  message: '',
};

const SuccessAlert: React.FC = () => {
  // HOOKS
  const dispatch = useDispatch();
  const successState = useAppSelector(getSuccessState);

  // LOCAL STATES
  const [alertData, setAlertData] = useState<IAlertData>({ ...initialState });

  // USE EFFECTS
  useEffect(() => {
    if (successState.visible) {
      setAlertData({
        visible: successState.visible,
        message: successState.message,
      });
    }
  }, [successState.visible]);

  // METHODS
  const handleClose = () => {
    setAlertData((prevState) => ({
      ...prevState,
      visible: false,
    }));
    dispatch(resetMessage());
  };

  // RENDER
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={alertData.visible}
      onClose={handleClose}
      autoHideDuration={4000}
      TransitionProps={{ onExited: () => handleClose() }}
      action={
        <>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    >
      <Alert
        onClose={handleClose}
        severity="success"
        icon={<CheckCircleOutlineIcon sx={{ color: 'rgb(76, 175, 80)' }} />}
        sx={contentStyles}
      >
        {alertData.message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessAlert;
